import { Box, Card, CardMedia, Grid, Typography } from "@mui/material";
import aws from "assets/partners/aws.svg";
// import nasscom from "assets/partners/nasscom.svg";
import nasscom from "assets/partners/deepTech.png";
import innovation from "assets/partners/innovation.svg";
import jestro from "assets/partners/jetro.svg";
import mgdeveloper from "assets/partners/mgdeveloper.svg";
import nvidia from "assets/partners/nvidia.svg";
import oracle from "assets/partners/oracle.svg";
import rockstart from "assets/partners/rockstart.svg";
import startupindia from "assets/partners/startupindia.svg";
import thub from "assets/partners/thub.svg";
import React from "react";

// Array to store partner data
const partners = [
  { id: 1, name: "nvidia", src: nvidia },
  { id: 2, name: "oracle", src: oracle },
  { id: 3, name: "aws", src: aws },
  { id: 4, name: "rockstart", src: rockstart },
  { id: 5, name: "innovation", src: innovation },
  { id: 6, name: "startupindia", src: startupindia },
  { id: 7, name: "nasscom", src: nasscom },
  { id: 8, name: "mgdeveloper", src: mgdeveloper },
  { id: 9, name: "jestro", src: jestro },
  { id: 10, name: "thub", src: thub },
];

const gridItemStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "0.625rem",
};

const cardMediaStyles = {
  width: "100%",
  height: "100%",
  borderRadius: "0.625rem",
  objectFit: "contain",
  filter: "grayscale(100%)",
  transition: "all 0.3s ease",
  "&:hover": {
    filter: "grayscale(0%)",
  },
};

export default function OurPartners() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        // padding: "2.5rem 1.25rem",
      }}
    >
      <Typography
        gutterBottom
        sx={{
          color: "#020A0D",
          textAlign: "center",
          fontFamily: "Inter",
          fontWeight: 600,
          lineHeight: "140%",
          transform: "rotate(0.103deg)",
          alignSelf: "stretch",
          fontSize: {
            xs: "19px",
            sm: "28px",
            lg: "40px",
          },
        }}
      >
        Our Partners
      </Typography>

      <Card
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 3,
          alignSelf: "stretch",
          flexWrap: "wrap",
          borderRadius: "1.875rem",
          background: "#FEFFFF",
          boxShadow: "0px 0.5rem 1.5rem 0px rgba(78, 100, 122, 0.15)",
          padding: "1.25rem",
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            rowGap: "0.75rem",
            padding: "3rem 0",
          }}
        >
          {partners.map(({ id, src, name }) => (
            <Grid item xs={6} sm={2.4} md={2.4} key={id} sx={gridItemStyles}>
              <CardMedia component="img" src={src} alt={`partner-${name}`} sx={cardMediaStyles} />
            </Grid>
          ))}
        </Grid>
      </Card>
    </Box>
  );
}
